import { Component, computed, inject, input } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { getFieldValue, TextInterpolationPipe } from '@core/jss-utils';
import {
  getMGMSharedValue,
  getOrderOverviewFields,
  getYearlyCostsLabel,
  OfferUspsComponent,
} from '@innogy/become-a-customer/shared';
import { getFeatureFlags } from '@innogy/become-a-customer/state';
import { hasMemberGetMember } from '@innogy/shared/member-get-member';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TrackLinkDirective } from '@analytics/events';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import {
  RichTextWrapperComponent,
  ToolTipComponent,
} from '@legacy/common-ui-utility-components';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SvgSkeletonLoaderComponent } from '@legacy/common-ui-shared';

import { OrderOverviewBudgetBillComponent } from '../order-overview-shared/order-overview-budget-bill/order-overview-budget-bill.component';
import { BaseOrderOverviewComponent } from '../base-order-overview/base-order-overview.component';
import { OrderOverviewConsumptionComponent } from '../order-overview-shared/order-overview-consumption/order-overview-consumption.component';
import { OfferOverviewChangeOfferComponent } from '../order-overview-shared/offer-overview-change-offer/offer-overview-change-offer.component';

@Component({
  selector: 'ed-order-overview',
  templateUrl: './order-overview-ed.component.html',
  styleUrls: ['./order-overview-ed.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    JssModule,
    NgbModule,
    AutomationIdDirective,
    CSCaptureDirective,
    TrackLinkDirective,
    AutomationIdDirective,
    ToolTipComponent,
    RichTextWrapperComponent,
    OrderOverviewBudgetBillComponent,
    OfferOverviewChangeOfferComponent,
    OrderOverviewConsumptionComponent,
    SvgSkeletonLoaderComponent,
    OfferUspsComponent,
    TextInterpolationPipe,
    RoundedCurrencyPipe,
  ],
})
export class OrderOverviewEdComponent extends BaseOrderOverviewComponent {
  protected readonly store$ = inject(Store);
  private readonly environmentConfig = inject(ENVIRONMENT_CONFIG);

  readonly memberGetMemberSharedValue = input('');

  readonly hasMemberGetMember = this.store$.selectSignal(hasMemberGetMember);
  readonly termijnbedragVariantA = this.store$.selectSignal(
    getFeatureFlags('termijnbedragVariantA')
  );
  readonly termijnbedragVariantB = this.store$.selectSignal(
    getFeatureFlags('termijnbedragVariantB')
  );

  readonly mgmSharedValue = computed(() =>
    getMGMSharedValue(this.offer(), this.environmentConfig.brand)
  );
  readonly yearlyCostLabel = computed(() =>
    getYearlyCostsLabel(
      ...getOrderOverviewFields(this.rendering()),
      this.offer()
    )
  );
  readonly getFieldValueBBAFeatureFlag = computed(() =>
    getFieldValue<boolean>(this.rendering(), 'EnableRemoveBBA')
  );
  readonly displayMGM = computed(
    () => this.hasMemberGetMember() && !!this.mgmSharedValue()
  );
}
